// First-screen hand-off for the boot splash in index.html: whichever screen
// mounts first (a console route via PageTransition, or the Login page) tells
// the splash it can fade. Idempotent; safe to call from many places.
import { useEffect } from "react";

export function dismissSplash(): void {
  // Two frames so the first paint of the mounted screen is on screen before the
  // splash starts fading (the fade then reveals real content, never a blank).
  requestAnimationFrame(() => requestAnimationFrame(() => window.__pbSplash?.done()));
}

export function useSplashDismiss(): void {
  useEffect(() => {
    dismissSplash();
  }, []);
}
